export default {"src":"/_next/static/media/expand.57b1a982.svg","height":30,"width":30};